
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'tableSimple',

  props: {
    rows: Array
  },

  setup() {
    interface TableItem {
      th: string
      td: string
      thChild?: string
      tdChild?: string
      kana?: string
      sub?: string
      link?: boolean
      mail?: boolean
      tel?: boolean
      smRowLayout?: boolean
    }

    const setTh = (item: TableItem) => {
      let html = item.th

      if (item.thChild) {
        html += '<br><span class="child">' + item.thChild + '</span>'
      }

      return html
    }

    const setTd = (item: TableItem) => {
      let html = ''

      if (item.link === true) {
        html = `<a href="${item.td}" target="_blank">${item.td}</a>`
      } else if (item.mail === true) {
        html = `<a href="mailto:${item.td}">${item.td}</a>`
      } else if (item.tel === true) {
        html = `<a href="tel:${item.td}">${item.td}</a>`
      } else if (item.kana) {
        html = `${item.td}<span class="kana">${item.kana}</span>`
      } else if (item.sub) {
        html = `${item.td}<span class="sub">${item.sub}</span>`
      } else {
        html = item.td.replace(/\r?\n/g, '<br>')
      }

      if (item.tdChild) {
        html += '<br>' + item.tdChild
      }

      return html
    }

    return {
      setTh,
      setTd
    }
  }
})
